import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

import { LANDING_COLORS } from '../../../constants'
import { hairlineBorder } from '../../../lib/hairline'

export type CautionVariant = 'info' | 'danger'

const HEADER_COLOR: Record<CautionVariant, string> = {
  info: COLORS.textSecondary,
  danger: LANDING_COLORS.negative,
}

const BOX_BG: Record<CautionVariant, string> = {
  info: COLORS.bgSubtle,
  danger: LANDING_COLORS.consCardBg,
}

const BOX_BORDER: Record<CautionVariant, string> = {
  info: '#B8B8B8',
  danger: LANDING_COLORS.consCardBorder,
}

/** danger 본문 텍스트 — negative보다 밝은 빨강 (시안값) */
const TEXT_COLOR: Record<CautionVariant, string> = {
  info: COLORS.textSecondary,
  danger: '#FF6B6B',
}

export const CautionContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  /* 좁은 화면에서 좌우 30px 은 콘텐츠 폭을 과하게 깎음 — 20px 로 완화 */
  padding: 50px 20px;
  background-color: ${COLORS.bgWhite};
`

export const CautionGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
`

export const CautionItemWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`

export const CautionHeader = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
`

export const CautionIcon = styled.img`
  width: 22px;
  height: 22px;
`

export const CautionTitle = styled('p', {
  shouldForwardProp: (prop) => prop !== 'variant',
})<{ variant: CautionVariant }>`
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.33px;
  color: ${({ variant }) => HEADER_COLOR[variant]};
`

export const CautionBox = styled('div', {
  shouldForwardProp: (prop) => prop !== 'variant',
})<{ variant: CautionVariant }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  /* 우측 패딩 추가 — 자동 줄바꿈 시 텍스트가 border 에 붙는 문제 방지 */
  padding: 24px 20px;
  border-radius: 4px;
  background-color: ${({ variant }) => BOX_BG[variant]};
  /* 0.5px 하단 변이 일부 webview 에서 사라지는 문제 — 레티나 헤어라인으로 대응 */
  ${({ variant }) => hairlineBorder(BOX_BORDER[variant])}
`

export const CautionLine = styled('p', {
  shouldForwardProp: (prop) => prop !== 'variant',
})<{ variant: CautionVariant }>`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  /* 좁은 화면에서 자동 줄바꿈될 때 행간 확보 (기존 1.0 → 1.5) */
  line-height: 1.5;
  letter-spacing: -0.21px;
  word-break: keep-all;
  color: ${({ variant }) => TEXT_COLOR[variant]};

  strong {
    font-weight: 700;
  }
`
